import { Typography } from '../../components/primitives';
import { testId } from '../../utils';
import { SettingsAccount } from './SettingsAccount';
import { useTranslation } from '@rpi/i18n';
import React from 'react';

export const SettingsView: React.FC = () => {
  const { t } = useTranslation(undefined, { keyPrefix: 'route.user.settings' });
  return (
    <div className="md:max-w-[940px] flex flex-col">
      <div className="mb-12">
        <Typography variant="title-default" {...testId('settings-title')}>
          {t('settings_title')}
        </Typography>
      </div>
      <div className="mb-6">
        <Typography variant="title-small" {...testId('account-subtitle')}>
          {t('info_section_text')}
        </Typography>
      </div>
      <SettingsAccount />
    </div>
  );
};
